/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, August 18th 2022, 10:45:16 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import Popover from "@mui/material/Popover";
import Paper from "@mui/material/Paper";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import CodeIcon from "@mui/icons-material/Code";
import StyleEditor from "react-style-editor";
import { TextField } from "@mui/material";

interface CSSEditorProps {
  defaultValue: string;
  onChangeLayoutCSS: (cssValue: string) => void;
}

export const CSSEditor = ({ defaultValue, onChangeLayoutCSS }: CSSEditorProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [showRawCSS, setShowRawCSS] = React.useState(false);

  const onClickContextMenu = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {showRawCSS ? (
        <TextField
          defaultValue={defaultValue}
          onChange={(event) => onChangeLayoutCSS(event.target.value)}
          onBlur={() => setShowRawCSS(false)}
          multiline
          rows={10}
        />
      ) : (
        <div onContextMenu={onClickContextMenu}>
          <StyleEditor
            defaultValue={defaultValue ? defaultValue : "div {}"}
            label="CSS"
            onChange={onChangeLayoutCSS}
            style={{ minWidth: 300 }}
          />
        </div>
      )}
      <Popover id="css-editor-context-menu" open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={handleClose}>
        <Paper sx={{ width: 160 }}>
          <MenuList className="user-popup" dense>
            <MenuItem onClick={() => setShowRawCSS(true)}>
              <ListItemIcon className="user-popup-icon">
                <CodeIcon />
              </ListItemIcon>
              Edit Source
            </MenuItem>
          </MenuList>
        </Paper>
      </Popover>
    </>
  );
};
